function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#002654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5h12.2v8.2H0V5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5h4v8H0V5Z",
    style: {
      fill: "#002654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,5h4v8h-4V5Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75,14.15l.644,1.025h1.831v3.575l-1.375-2.15-1.85,2.95h.9l.95-1.7,1.95,3.5,1.95-3.5.95,1.7h.9l-1.85-2.95-1.375,2.15v-1.975h.825l.612-.975h-1.438v-.625h1.831l.644-1.025h-6.099ZM19.9,18.525h-2v.7h2v-.7ZM23.7,18.525h-2v.7h2v-.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M20.8,22.05l.617,1.899-1.617-1.174h2l-1.617,1.174.617-1.899Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M18.55,20.35l.617,1.899-1.617-1.174h1.999l-1.617,1.174.618-1.899Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M23.05,20.35l.617,1.899-1.617-1.174h1.999l-1.617,1.174.618-1.899Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M16.65,15.3l.617,1.899-1.617-1.174h1.999l-1.617,1.174.618-1.899Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M24.95,15.3l.617,1.899-1.617-1.174h1.999l-1.617,1.174.618-1.899Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTf);
export default __webpack_public_path__ + "static/media/TF.e3da7025f9fe5467ab661da8cf168068.svg";
export { ForwardRef as ReactComponent };